/**
 * Edit contact details
 */
$(document).ready(function() {
    if ($('#TotemForm_EditNotificationForm_Body').length) {
        $('#TotemForm_EditNotificationForm_Body').kendoEditor({
            resizable: {
                content: true,
                toolbar: true
            }
        });
    }

    $('#email-display').on('load', function() {
        $('iframe')
            .contents()
            .find('head')
            .append($("<style type='text/css'>  body{background:none !important;}  </style>"));
    });

    var currentNotificationID = $('#TotemForm_EditNotificationForm_ID').val();

    $('#TotemForm_EditNotificationForm_Status')
        .on('change', function() {
            if ($(this).val() == 'scheduled') {
                $('#SendDate').show();
                $('#SentDate').hide();
            } else if ($(this).val() == 'sent') {
                $('#SendDate').hide();
                $('#SentDate').show();
            } else {
                $('#SendDate').hide();
                $('#SentDate').hide();
            }
        })
        .trigger('change');

    $('#documents-grid').on('click', '.attach-btn', function(e) {
        var currEle = $(this);
        var documentID = currEle.data('record-id');
        $.ajax({
            url: currEle.data('href'),
            data: { documentID: documentID, notificationID: currentNotificationID },
            dataType: 'json',
            type: 'POST'
        }).success(function(data) {
            if (data.status == 'success') {
                if (data.attachBtn == 1) {
                    currEle.text('Attach');
                } else {
                    currEle.text('Detach');
                }
            }
        });
    });

    if (typeof TotemDocumentDS !== 'undefined') {
        $('#documents-grid').kendoGrid({
            selectable: false, //'multiple,row',
            columns: [
                {
                    field: 'Title',
                    title: 'Title',
                    width: '200px'
                },
                {
                    field: 'Summary',
                    title: 'Summary',
                    width: '200px'
                },
                {
                    field: 'Size',
                    title: 'Size',
                    width: '125px'
                },
                {
                    field: 'VersionDate',
                    title: 'Version Date',
                    width: '200px'
                },
                {
                    filterable: false,
                    title: '',
                    width: '250px',
                    template:
                        '#if( typeof(IsAttached) !== "undefined" ) {#' +
                        '<a data-href="/affiliate/handleDocumentOnNotification/" id="attach-document-${ ID }" data-record-id="${ ID }" class="attach-btn btn small primary"> #if(IsAttached == 1){#Detach#}else{#Attach#}# </a>' +
                        '#} else {# ' +
                        '<a href="${ Link }" id="deactivate-document-${ ID }" data-record-id="${ ID }" class="btn btn-small btn-primary btn-slim">Download</a>  ' +
                        '#}#'
                }
            ],
            dataSource: TotemDocumentDS
        });
    }
});
